module.exports = __webpack_public_path__ + "static/media/tilogo.60b61aba.png";